import { useState } from 'react';

export const useLiveChat = () => {
  // Live chat states - extracted exactly from Customer.Layout.tsx
  const [isActive, setIsActive] = useState(false);
  const [chatMode, setChatMode] = useState<'options' | 'ai' | 'agent'>('options'); // Show options first

  const chatbtnClick = () => {
    setIsActive(prev => !prev);
  };

  const handleBackToOptions = () => {
    setChatMode('options');
  };

  return {
    isActive,
    chatMode,
    setChatMode,
    chatbtnClick,
    handleBackToOptions
  };
}; 